import config from "../config";

/**
 * Appelle la fonction Cloud "updateUserDeposit" pour mettre à jour le dépôt avec le prénom et le nom.
 * @param {string} depositId - L'identifiant du dépôt.
 * @param {string} firstName - Le prénom à associer.
 * @param {string} lastName - Le nom à associer.
 * @returns {Promise<Object>} - L'objet retourné par la Cloud Function.
 */
export async function updateUserDeposit(depositId, firstName, lastName) {
  const endpointURL = `${config.API_BASE_URL}/updateUserDeposit`;
  const response = await fetch(endpointURL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ depositId, firstName, lastName })
  });
  if (!response.ok) {
    throw new Error(`HTTP error: ${response.status}`);
  }
  return await response.json();
}
